// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  adalConfig: {
    clientId: '4d74d747-2c30-4230-886e-c994e3c4c6c7',
    tenant: 'c83ee60e-be9c-40e7-84ef-b8b9f4ace686',
    cacheLocation: 'localStorage'
  },
  apiUrl: 'https://tt-dev-api.tsp99.net/api',
  tspClientID: 13,
  newUiUrl: 'https://tt-dev.tsp99.net/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
